import { IEntity } from "@interfaces/entity";
import { ChargingStationByGroupDto } from "./chargingStationByGroupDto";
import { RfidCardDto } from "./rfidCardDto";
import { PricingDto } from '@dto/pricingDto';
import { Address } from "../models/address";
import { ChargingstationGroupDto } from "./chragingstationGroupDto";

export class UserEditDto implements IEntity {
  id: string;
  email: string;
  username: string;
  firstName: string;
  lastName: string;
  fullName: string;
  gender: string;
  rfidCardsString: string;
  allowedChargingStationsString: string;
  selectedCustomerId: number;
  subscriptionTypeId: number;
  rfidCards: RfidCardDto[];
  pricing?: PricingDto;
  address?: Address;
  pricingId?: number;
  pricingName: string;
  chargingStations: ChargingStationByGroupDto[];
  chargingGroups: ChargingstationGroupDto[];
  chargingPowerProfileId: number;
  organisationMail: string;
  /** Rolle des Nutzers für den ausgewählten Kunden (User, Technical, Account). */
  roleName?: string;

  entityName = "UserEditDto";

  getPrimaryKey() {
    return this.id;
  }

  updateValues(formValue: Partial<UserEditDto>) {
    Object.assign(this, formValue);
  }

}
